import { render, staticRenderFns } from "./ModalDetailTraining.vue?vue&type=template&id=2b80d1a3&"
import script from "./ModalDetailTraining.vue?vue&type=script&lang=js&"
export * from "./ModalDetailTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports